import ActivityNotifications from "@/components/7fcc/ActivityNotifications";
import { ACTIVITY_NOTIFICATIONS } from "@/data/militaryContent";
import {
  MilitaryHero,
  MilitaryVslSection,
  MilitaryQuizSection,
  MilitaryProofSection,
  MilitaryVideoWinsSection,
  MilitaryFaqSection,
  MilitaryBottomCta,
  MilitaryFooter,
} from "@/sections/military/MilitarySections";

// The /military campaign page — standalone mirror of /ready, fully fed
// from src/data/militaryContent.js. Not linked from any site navigation.
export default function MilitaryPage() {
  return (
    <div className="theme-military">
      {/* Funnel: hero → VSL → survey + John Pierre spotlight → proof → wins → FAQ */}
      <MilitaryHero />
      <MilitaryVslSection />
      <MilitaryQuizSection />
      <MilitaryProofSection />
      <MilitaryVideoWinsSection />
      <MilitaryFaqSection />
      <MilitaryBottomCta />
      <MilitaryFooter />
      <ActivityNotifications notifications={ACTIVITY_NOTIFICATIONS} />
    </div>
  );
}
